export { fetchAsset } from './fetch-asset.ts'
export type { FetchAssetOptions } from './fetch-asset.ts'